import { createSlice } from "@reduxjs/toolkit";
import { BookingModel } from "../pages/CounterPanel/helpers/booking-helper";

// Define initial state
const initialState = {
    isLoading: false,
    isCompanyCallCenterSearchDataChanged: null,
    isNewBookingActionOccured: null,
    tripSearch: {
        companyId: null,
        counterId: null,
        counterUserId: null,
        from: null,
        fromType: "station",
        to: null,
        toType: "station",
        tripNo: null,
        departureDate: null,
        departureTime: null,
    },
    triggerTripSearch: null,
    resetTrips: null,
    travelMode: null,
    departureTimes: [],
    counterInfo: null,
    companyConfig: [],
    booking: BookingModel(),
    removingSeat: null,
    goodsPolicy: {
        fareEditOption: null,
        perSeatFree: null,
        rate: null,
        status: null,
    },
};

// Define the slice
const counterPanelTripSearchSlice = createSlice({
    name: "counter-panel-trip-search",
    initialState,
    reducers: {
        setTripSearchData: (state, action) => {
            const tripSearch = action.payload;
            return { ...state, tripSearch };
        },
        setDepartureTimes: (state, action) => {
            const departureTimes = action.payload;
            return {
                ...state,
                departureTimes,
            };
        },
        setIsLoading: (state, action) => {
            const isLoading = action.payload;
            return {
                ...state,
                isLoading,
            };
        },
        setTravelMode: (state, action) => {
            const travelMode = action.payload;
            return {
                ...state,
                travelMode,
            };
        },
        setCounterInfo: (state, action) => {
            const counterInfo = action.payload;
            return {
                ...state,
                counterInfo,
            };
        },
        setCompanyConfig: (state, action) => {
            const companyConfig = action.payload;
            return {
                ...state,
                companyConfig,
            };
        },
        setTriggerTripSearch: (state, action) => {
            const triggerTripSearch = action.payload;
            return {
                ...state,
                triggerTripSearch,
            };
        },
        // To Do: apply it instead of local state.
        setBooking: (state, action) => {
            const booking = action.payload;
            return {
                ...state,
                booking,
            };
        },
        setRemovingSeat: (state, action) => {
            const removingSeat = action.payload;
            return {
                ...state,
                removingSeat,
            };
        },
        setGoodsPolicy: (state, action) => {
            const goodsPolicy = action.payload;
            return {
                ...state,
                goodsPolicy,
            };
        },
        setResetTrips: (state, action) => {
            const resetTrips = action.payload;
            return {
                ...state,
                resetTrips,
            };
        },
        setIsCompanyCallCenterSearchDataChanged: (state, action) => {
            const isCompanyCallCenterSearchDataChanged = action.payload;
            return {
                ...state,
                isCompanyCallCenterSearchDataChanged,
            };
        },
        setIsNewBookingActionOccured: (state, action) => {
            const isNewBookingActionOccured = action.payload;
            return {
                ...state,
                isNewBookingActionOccured,
            };
        },
    },
});

// Export the actions and reducer
export const {
    setTripSearchData,
    setDepartureTimes,
    setIsLoading,
    setTravelMode,
    setCounterInfo,
    setCompanyConfig,
    setTriggerTripSearch,
    setBooking,
    setRemovingSeat,
    setGoodsPolicy,
    setResetTrips,
    setIsCompanyCallCenterSearchDataChanged,
    setIsNewBookingActionOccured,
} = counterPanelTripSearchSlice.actions;
export default counterPanelTripSearchSlice.reducer;
